const ACTIONS = {
  RESET_CHARGER_CONFIG: "RESET_CHARGER_CONFIG",
  FETCH_CHARGER_CONFIG_INIT: "FETCH_CHARGER_CONFIG_INIT",
  FETCH_CHARGER_CONFIG_SUCCESS: "FETCH_CHARGER_CONFIG_SUCCESS",
  FETCH_CHARGER_CONFIG_FAILURE: "FETCH_CHARGER_CONFIG_FAILURE",
  SEND_OCPP_COMMAND_INIT: "SEND_OCPP_COMMAND_INIT",
  SEND_OCPP_COMMAND_SUCCESS: "SEND_OCPP_COMMAND_SUCCESS",
  SEND_OCPP_COMMAND_FAILURE: "SEND_OCPP_COMMAND_FAILURE",
};

export default ACTIONS;
